import React, {createContext, useEffect, useState} from 'react';
import AdminBillsTab from "./Partials/AdminBillsTab";
import {SortingTable} from "../../../../components/Molecules/Tables/SortingTable";
import {getInvoicesDownPaymentsColumns} from "../../../../config/ArrayColumns/Admin/InvoicesDownPayments";
import ButtonWithOnClickAction from "../../../../components/Atomes/Buttons/ButtonWithOnClickAction";
import TitleWithExport from "../../../../components/Molecules/Title/TItleWIthExport";
import FilterSearchTwoSelectsDatepicker from "../../../../components/Molecules/Filter/FilterSearchTwoSelectsDatepicker";
import moment from "moment";
import {BillService} from "../../../../services/BillService";
import {ConvertObjectToParams, ConvertObjectToUrlParams} from "../../../../utils/StringUtils";
import {AssetsPayments} from "../../../../config/ArrayColumns/Admin/AssetsPayments";
import {toast} from "react-toastify";
import {StateProjectPayments} from "../../../../config/ArrayColumns/Admin/StateProjectPayments";
import exportFileService from "../../../../services/ExportFileService";
import {dataRegionsArray} from "../../../../utils/RegionsUtils";

const paymentStatusOptions = ["Toutes les factures", "Factures payées", "Factures non payées"]
const paymentStatusValues = ["all", "paid", "unpaid"]

export const StateRequest = createContext()

const AdminBills = () => {

	const [activeSection, setActiveSection] = useState("invoices-down-payments");

	//Search
	const [search, setSearch] = useState("");

	//State request
	const [stateRequest, setStateRequest] = useState("");

	//Invoices
	const [invoicesDownPayments, setInvoicesDownPayments] = useState([]);
	const [invoicesFinal, setInvoicesFinal] = useState([]);
	const [assets, setAssets] = useState([]);
	const [stateProject, setStateProject] = useState([]);

	//Date
	const [dateStart, setDateStart] = useState("");
	const [dateEnd, setDateEnd] = useState("");
	const [date, setDate] = useState(new Date());

	const options = dataRegionsArray
	const [region, setRegion] = useState("");
	const [paymentStatus, setPaymentStatus] = useState("paid");

	const [urlToExport, setUrlToExport] = useState("");

	const changeDate = (date) => {
		setDate(date)
		setDateStart(moment(date[0]).format("YYYY-MM-DD"))
		setDateEnd(moment(date[1]).add(1, "days").format("YYYY-MM-DD"))
	}

	const sectionToReturn = () => {
		if (activeSection === "invoices-down-payments") {
			return (
				<SortingTable columnsTable={getInvoicesDownPaymentsColumns(activeSection, setStateRequest)} dataTable={invoicesDownPayments}/>
			)
		} else if (activeSection === "invoices-final") {
			return (
				<SortingTable columnsTable={getInvoicesDownPaymentsColumns(activeSection, setStateRequest)} dataTable={invoicesFinal}/>
			)
		} else if (activeSection === "asset") {
			return (
				<SortingTable columnsTable={AssetsPayments} dataTable={assets}/>
			)
		} else if (activeSection === "state-project") {
			return (
				<SortingTable columnsTable={StateProjectPayments} dataTable={stateProject}/>
			)
		}
	}

	const setUrl = () => {
		if (activeSection === "invoices-down-payments") {
			setUrlToExport(ConvertObjectToUrlParams("/admin/deposits", {
				...buildPaymentFilters(),
				region: region,
				dateStart: dateStart,
				dateEnd: dateEnd,
				search: search
			}))
		} else if (activeSection === "invoices-final") {
			setUrlToExport(ConvertObjectToUrlParams("/admin/invoices", {
				...buildPaymentFilters(),
				region: region,
				dateStart: dateStart,
				dateEnd: dateEnd,
				search: search
			}))
		} else if (activeSection === "asset") {
			setUrlToExport(ConvertObjectToUrlParams("/admin/credits", {
				...buildPaymentFilters(),
				region: region,
				dateStart: dateStart,
				dateEnd: dateEnd,
				search: search
			}))
		} else if (activeSection === "state-project") {
			setUrlToExport("#")
		}
	}

	const resetDate = () => {
		setDate(new Date())
		setDateStart("")
		setDateEnd("")
	}

	const buildPaymentFilters = () => {
		if (paymentStatus === "paid") {
			return {"exists[payment]": "true", "exists[paidAt]": "true"}
		}
		if (paymentStatus === "unpaid") {
			return {"exists[payment]": "false", "exists[paidAt]": "false"}
		}
		return {}
	}

	const getInvoiceOnAccount = async () => {
		const request = await BillService.getInvoiceOnAccount(ConvertObjectToUrlParams("deposits", {
			...buildPaymentFilters(),
			"project.region": region,
			"createdAt[after]": dateStart,
			"createdAt[before]": dateEnd,
			search: search,
			"pagination": "true"
		}))
		if (request.status === 200) {
			setInvoicesDownPayments(request.data)
		}
	}

	const getInvoiceFinal = async () => {
		const request = await BillService.getInvoiceOnAccount(ConvertObjectToUrlParams("final-invoices", {
			...buildPaymentFilters(),
			"project.region": region,
			"createdAt[after]": dateStart,
			"createdAt[before]": dateEnd,
			search: search,
			"pagination": "true"
		}))
		if (request.status === 200) {
			setInvoicesFinal(request.data)
		}
	}

	const getAssets = async () => {
		const request = await BillService.getInvoiceOnAccount(ConvertObjectToUrlParams("credits", {
			"project.region": region,
			"createdAt[after]": dateStart,
			"createdAt[before]": dateEnd,
			search: search,
			"pagination": "true"
		}))
		if (request.status === 200) {
			setAssets(request.data)
		}
	}

	const getStateProject = async () => {
		const request = await BillService.getInvoiceOnAccount(ConvertObjectToUrlParams("final-invoices", {
			...buildPaymentFilters(),
			"project.region": region,
			"createdAt[after]": dateStart,
			"createdAt[before]": dateEnd,
			search: search,
			"pagination": "true"
		}))
		if (request.status === 200) {
			setStateProject(request.data)
		}
	}

	const todayDate = moment().format("L").split("/").join("-")

	const downloadFile = () => {
		const date = moment().format("L").split("/").join("-")
		exportFileService.exportFile(`/fec`, `export-fec-${date}`, {
			dateStart: dateStart,
			dateEnd: dateEnd,
			search: search,
			region: region,
			...buildPaymentFilters()
		}, "zip")
	}

	const downloadFileZipAcomptes = () => {
		const date = moment().format("L").split("/").join("-")
		exportFileService.exportFile(`/zip/deposits`, `export-acompte-finale-${date}`, {
			dateStart: dateStart,
			dateEnd: dateEnd,
			search: search,
			region: region,
			...buildPaymentFilters()
		}, "zip")
	}
	const downloadFileZipFInales = () => {
		const date = moment().format("L").split("/").join("-")
		exportFileService.exportFile(`/zip/invoices`, `export-facture-finale-${date}`, {
			dateStart: dateStart,
			dateEnd: dateEnd,
			search: search,
			region: region,
			...buildPaymentFilters()
		}, "zip")
	}
	const downloadFileZipAvoirs = () => {
		const date = moment().format("L").split("/").join("-")
		exportFileService.exportFile(`/zip/credits`, `export-avoirs-${date}`, {
			dateStart: dateStart,
			dateEnd: dateEnd,
			search: search,
			region: region,
			...buildPaymentFilters()
		}, "zip")
	}
	const downloadFileXmlAvoirs = () => {
		const date = moment().format("L").split("/").join("-")
		exportFileService.exportFile(`/xml/credits`, `export-avoir-xml-${date}`, {
			dateStart: dateStart,
			dateEnd: dateEnd,
			search: search,
			region: region,
			...buildPaymentFilters()
		}, "xml")
	}

	const DisplayToast = (type) => {
		if (type === "success edit") {
			toast.success("Le commentaire a bien été modifié")
		} else if (type === "success add asset") {
			toast.success("L'avoir a bien été ajouté")
		} else if (type === "success upload proof") {
			toast.success("La preuve de virement a bien été chargée")
		} else if (type === "error") {
			toast.error("Une erreur est survenue")
		}
		setStateRequest("")
	}

	useEffect(() => {
		if (stateRequest !== "") {
			DisplayToast(stateRequest)
		}

		const fetchDataBySection = () => {
			if (activeSection === "invoices-down-payments") {
				return getInvoiceOnAccount()
			} else if (activeSection === "invoices-final") {
				return getInvoiceFinal()
			} else if (activeSection === "asset") {
				return getAssets()
			} else if (activeSection === "state-project") {
				return getStateProject()
			}
		}

		fetchDataBySection()
		setUrl()
	}, [dateStart, dateEnd, search, region, stateRequest, activeSection, paymentStatus]);

	const changeRegion = (region) => {
		if (region === "Toutes les agences") {
			setRegion("")
		} else {
			setRegion(region)
		}
	}

	const handlePaymentStatusChange = (event) => {
		setPaymentStatus(event.target.value)
	}

	return (
		<StateRequest.Provider value={{stateRequest, setStateRequest}}>
			<div className={"admin-bills-filters"}>
				<FilterSearchTwoSelectsDatepicker
					onFirstChange={(event) => changeRegion(event.target.value)}
					firstValue={options}
					firstOptions={options}
					firstDefaultValue={"Toutes les agences"}
					firstSelectedValue={region === "" ? "Toutes les agences" : region}
					secondDefaultValue={"Toutes les factures"}
					secondOptions={paymentStatusOptions}
					secondValue={paymentStatusValues}
					secondSelectedValue={paymentStatus}
					showSecondDefaultOption={false}
					onSecondChange={handlePaymentStatusChange}
					date={date}
					placeHolderSearch={"Entrer la recherche puis valider"}
					onChangeDate={(date) => changeDate(date)}
					onSearch={(event) => event.key === "Enter" ? setSearch(event.target.value.toLowerCase()) : null}
					onChangeSearchValue={(event) => event.target.value.length === 0 ? setSearch("") : null}
					resetDateSelected={resetDate}
				/>
			</div>

			<TitleWithExport dark={true} buttonExport={activeSection === "state-project"} title={"Facturation"}
			                 titleButton={"Exporter"} url={urlToExport} fileName={`export-facture-${todayDate}`}
			                 fileType={"xlsx"}/>
			<div className={"admin-bills-content "}>
				<div className={"admin-bills-content-container mbe-section "}>
					<div>
						<AdminBillsTab activeSection={activeSection} setActiveSection={setActiveSection}/>
						{sectionToReturn()}
					</div>
					{
						activeSection === "invoices-down-payments" ? (
							<div className={"admin-bills-content-container-button"}>
								<ButtonWithOnClickAction onClick={() => urlToExport !== "#" ? downloadFileZipAcomptes() : null}
								                         title={"Exporter factures acomptes"}
								                         styleButton={"btn-default btn-default-secondary plain"} isActive={true}/>
								<ButtonWithOnClickAction onClick={() => urlToExport !== "#" ? downloadFile() : null}
								                         title={"Exporter FEC"} styleButton={"btn-default btn-default-secondary plain"}
								                         isActive={true}/>
							</div>
						) : null
					}

					{
						activeSection === "invoices-final" ? (
							<div className={"admin-bills-content-container-button"}>
								<ButtonWithOnClickAction onClick={() => urlToExport !== "#" ? downloadFileZipFInales() : null}
								                         title={"Exporter factures finales"}
								                         styleButton={"btn-default btn-default-secondary plain"} isActive={true}/>
								<ButtonWithOnClickAction onClick={() => urlToExport !== "#" ? downloadFile() : null}
								                         title={"Exporter FEC"} styleButton={"btn-default btn-default-secondary plain"}
								                         isActive={true}/>
							</div>
						) : null
					}

					{
						activeSection === "asset" ? (
							<div className={"admin-bills-content-container-button"}>
								<ButtonWithOnClickAction onClick={() => urlToExport !== "#" ? downloadFileXmlAvoirs() : null}
								                         title={"Exporter paiement avoir"}
								                         styleButton={"btn-default btn-default-secondary plain"} isActive={true}/>
								<ButtonWithOnClickAction onClick={() => urlToExport !== "#" ? downloadFileZipAvoirs() : null}
								                         title={"Exporter avoirs"}
								                         styleButton={"btn-default btn-default-secondary plain"} isActive={true}/>
							</div>
						) : null
					}

				</div>
			</div>
		</StateRequest.Provider>
	);
};

export default AdminBills;
